import { toast } from "react-toastify";
import {
    fetchCreateLocationRequest,
    fetchCreateLocationSuccess,
    fetchCreateLocationFailure,
} from "./reducer";
import { CREATE_LOCATION } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createLocation = (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreateLocationRequest());
    setLoading(true);

    try {
        const response = await determineBaseUrlAndPerformApiCall(
            CREATE_LOCATION,
            "POST",
            jsonObj
        );

        if (response?.error) {
            dispatch(fetchCreateLocationFailure(response.error.message));
            toast.error(response.error.message);
        } else {
            dispatch(fetchCreateLocationSuccess(response));
            dispatch(setSuccessMessage(true));
            onSuccess && onSuccess();
        }
    } catch (error) {
        dispatch(fetchCreateLocationFailure("Something went wrong"));
        toast.error("Something went wrong");
    } finally {
        setLoading(false);
    }
};